import { BrowserRouter } from 'react-router-dom';
import AuthMiddleware from '../Helpers/AuthMiddleware';
import SiteRoutes from './SiteRoutes';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { darkTheme, lightTheme } from '../theme/theme';
import { restoreTheme } from '../redux/features/themeSlice';
import "react-toastify/ReactToastify.min.css";
import { restoreInformes } from '../redux/features/cartSlice';
import { useEffect } from 'react';

const SiteRouter = () => {

    const dispatch = useAppDispatch()
    const isDark = useAppSelector(state => state.theme.darkTheme)

    useEffect(() => {
        dispatch(restoreTheme())
        dispatch(restoreInformes())
    }, [dispatch])


    return (
        <BrowserRouter>
            <AuthMiddleware>
                <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
                    <CssBaseline enableColorScheme />
                    <ToastContainer />
                    <SiteRoutes />
                </ThemeProvider>
            </AuthMiddleware>
        </BrowserRouter>
    );
}

export default SiteRouter;